<div *ngIf="dataActual; else sinInfo" class="container_herramienta">
  <!-- Se muestra si existe imagen (desktop) -->
  <img
    class="img_toAnimate"
    *ngIf="dataActual?.imagen"
    [src]="dataActual.imagen"
    alt="Imagen promoción"
  />

  <div class="alinearIzq">
    <h1 class="title-section">{{ dataActual.titulo }}</h1>

    <!-- Se muestra si existe imagen (mobile) -->
    <img
      class="img_forMobil"
      *ngIf="dataActual?.imagen"
      [src]="dataActual.imagen"
      alt="Imagen promoción"
    />

    <div class="descripcion_cont">
      <!-- Descripción -->
      <p
        *ngIf="dataActual?.descripcion"
        [innerText]="dataActual.descripcion"
        style="white-space: pre-line;"
      ></p>

      <!-- ¿Cómo funciona? (beneficios) -->
      <div *ngIf="dataActual?.beneficios?.length > 0">
        <h3>¿Cómo funciona?</h3>
        <ul>
          <li *ngFor="let beneficio of dataActual.beneficios">
            {{ beneficio }}
          </li>
        </ul>
      </div>

      <!-- Niveles de depósito y descuento (tabla) -->
      <div *ngIf="dataActual?.niveles?.length > 0" class="niveles-cont">
        <h3>Niveles de depósito y descuento:</h3>

        <div class="tabla-niveles">
          <div class="fila encabezado">
            <div>Depósito / Recarga</div>
            <div>Descuento en envíos</div>
          </div>

          <div class="fila" *ngFor="let n of dataActual.niveles">
            <div>{{ n.deposito }}</div>
            <div>{{ n.descuento }}</div>
          </div>
        </div>

        <p
          *ngIf="dataActual?.notaNiveles"
          style="white-space: pre-line;"
        >
          {{ dataActual.notaNiveles }}
        </p>
      </div>

      <!-- ¿Quiénes aplican? -->
      <div *ngIf="dataActual?.aplican?.length > 0">
        <h3>¿Quiénes aplican?</h3>
        <ul>
          <li *ngFor="let item of dataActual.aplican">
            {{ item }}
          </li>
        </ul>
      </div>

      <!-- Si quieres mantener un texto libre extra (compatibilidad con tu campo previo) -->
      <p
        *ngIf="dataActual?.nivelesDcto"
        [innerText]="dataActual.nivelesDcto"
        style="white-space: pre-line;"
      ></p>

      <!-- Términos y condiciones -->
      <h3 *ngIf="dataActual?.terminos?.length > 0">Términos y condiciones</h3>
      <ul class="terminos-lista" *ngIf="dataActual?.terminos?.length > 0">
        <li *ngFor="let termino of dataActual.terminos" [innerHTML]="termino"></li>
      </ul>

      <!-- Texto navidad (si existe en otras promos) -->
      <p
        *ngIf="dataActual?.textonavidad"
        [innerText]="dataActual.textonavidad"
        style="white-space: pre-line; text-align: center;"
      ></p>

      <!-- Bases (si existe en otras promos) -->
      <p class="bases" *ngIf="dataActual?.bases" [innerText]="dataActual.bases"></p>

      <!-- Botón -->
      <div class="content_button" *ngIf="dataActual?.boton?.length > 0">
        <div class="buttonAction" routerLink="/guias-web">Comprar ahora</div>
      </div>
    </div>
  </div>
</div>

<!-- Se muestra si no existen datos -->
<ng-template #sinInfo>
  <p>No hay información disponible para esta promoción.</p>
</ng-template>